export default {"src":"/_next/static/media/googlePlay.9b2c051c.svg","height":80,"width":250,"blurWidth":0,"blurHeight":0};